import { useState } from "react";

export default function RadioButton({ checked, onChange }) {
  const toggle = () => {
    onChange && onChange(true);
  };

  return (
    <div
      onClick={toggle}
      style={{
        width: "26px",
        height: "26px",
        borderRadius: "50%",
        border: checked ? "7px solid #1B5CFF" : "2px solid #1B5CFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all ease 0.2s"
      }}
    >
      {checked && (
        <div
          style={{
            width: "12px",
            height: "12px",
            background: "rgba(253, 253, 253, 1)",
            borderRadius: "50%",
            transition: "all ease 0.2s"
          }}
        />
      )}
    </div>
  );
}
